enum ConditionType {
    Poison = "Poison",
    Immobilize = "Immobilize",
    Strengthen = "Strengthen",
    Muddle = "Muddle",
    Stun = "Stun",
    Wounded = "Wounded",
    Disarm = "Disarm",
    Heal = "Heal",
    Invisible = "Invisible",
    ShortRest = "ShortRest",
    LongRest = "LongRest"
}
